import React, { useEffect, useRef, useState } from 'react'
import { NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { logout } from '../../../Actions/Auth';
import '../MainHeader.css';
import styles from './AdminHeader.module.css';
import BreatheEV_Logo from '../../../Images/logo.png';
import { BiSolidWallet, BiSolidUser, BiMenuAltRight, BiCrosshair } from 'react-icons/bi';
import Image from 'react-bootstrap/Image';



const AdminHeader = (props) => {

  const [userMenu, setUserMenu] = useState(false);
  const userMenuRef = useRef(null);

  const [mobileMenu, setMobileMenu] = useState(false);
  const mobileMenuRef = useRef(null);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (userMenuRef.current && !userMenuRef.current.contains(event.target)) {
        setUserMenu(false);
      }

      if (mobileMenuRef.current && !mobileMenuRef.current.contains(event.target)) {
        setMobileMenu(false);
      }
    };

    document.addEventListener('click', handleOutsideClick);

    return () => {
      document.removeEventListener('click', handleOutsideClick);
    };
  }, [userMenu, mobileMenu]);

  return (
    <div className={"nav-header bottom-line"}>
      <div className="container nav">
        <NavLink to="/">
          <Image src={BreatheEV_Logo} alt="BreatheEV Logo" height={42} />
        </NavLink>
        {/* Start Larger screen menu */}
        <ul className={`navbar-nav ${styles["nav-larger"]}`}>
          <li className="nav-item">
            <NavLink className="nav-link" to="/">
              Dashboard
            </NavLink>
          </li>

          <li className="nav-item">
            <NavLink className="nav-link" to="/users">
              Users
            </NavLink>
          </li>

          <li className="nav-item">
            <NavLink className="nav-link" to="/guest-users">
              Guest Users
            </NavLink>
          </li>

          <li className="nav-item">
            <NavLink className="nav-link" to="/bookings">
              Bookings
            </NavLink>
          </li>

          <li className="nav-item">
            <NavLink className="nav-link" to="/supports">
              Support
            </NavLink>
          </li>

          <li className="nav-item">
            <NavLink className="nav-link" to="/locations">
              Locations
            </NavLink>
          </li>
          {/* <li className="nav-item">
            <NavLink className="nav-link" to="/metric" >
              Analytics
            </NavLink>
          </li> */}

          <li className="nav-item">
            <NavLink className="nav-link" to="/chargers">
              Chargers
            </NavLink>
          </li>

          <li
            className={
              userMenu ? "nav-item dropdown active" : "nav-item dropdown"
            }
            ref={userMenuRef}
          >
            <div
              className="dropdown-btn"
              onClick={() => {
                setUserMenu(!userMenu);
              }}
            >
              <BiSolidUser />
            </div>
            <div
              className="dropdown-menu-holder"
              onClick={() => {
                setUserMenu(false);
              }}
            >
              <div className="menu-tip" />
              <div className="menu-profile">
                <div className="menu-profile-icon">
                  <BiSolidUser />
                </div>
                <div className="menu-profile-name">{props.name}</div>
              </div>
              <ul>
                <li className="nav-item">
                  <NavLink className="nav-link" to="/coupon-code">
                    Coupon Codes
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink className="nav-link" to="/deals">
                    Deals
                  </NavLink>
                </li>
                 <li className="nav-item">
                                  <NavLink className="nav-link" to="/email-broadcast">
                                    Email Broadcast
                                  </NavLink>
                                </li>
                <li className="nav-item">
                  <NavLink className="nav-link" to="/message-templates">
                    Message Templates
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink className="nav-link" to="/app-guide">
                    App Guide
                  </NavLink>
                </li>

                <li className="nav-item">
                  <NavLink className="nav-link" to="/software-version">
                    Software Version
                  </NavLink>
                </li>

                <li className="nav-item">
                  <NavLink className="nav-link" to="/siteOnboarding">
                    Site Tracker
                  </NavLink>
                </li>

                <li className="nav-item">
                  <NavLink
                    onClick={props.logout}
                    className="nav-link"
                    to="/login"
                  >
                    Logout
                  </NavLink>
                </li>
              </ul>
            </div>
          </li>
        </ul>
        {/* End Larger screen menu */}

        {/* Start Mobile screen menu */}
        <ul className={`navbar-nav ${styles["nav-mobile"]}`}>
          <li
            className={
              mobileMenu ? "nav-item dropdown active" : "nav-item dropdown"
            }
            ref={mobileMenuRef}
          >
            <div
              className="dropdown-btn"
              onClick={() => {
                setMobileMenu(!mobileMenu);
              }}
            >
              {
                <BiMenuAltRight
                  className={
                    mobileMenu
                      ? `${styles["icon-rotate"]} ${styles["deg-180"]}`
                      : `${styles["icon-rotate"]}`
                  }
                />
              }
            </div>
            <div
              className="dropdown-menu-holder"
              onClick={() => {
                setMobileMenu(false);
              }}
            >
              <div className="menu-tip" />
              <div className="menu-profile">
                <div className="menu-profile-icon">
                  <BiSolidUser />
                </div>
                <div className="menu-profile-name">{props.name}</div>
              </div>
              <ul>
                <li className="nav-item">
                  <NavLink className="nav-link" to="/">
                    Dashboard
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink className="nav-link" to="/users">
                    Users
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink className="nav-link" to="/guest-users">
                    Guest Users
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink className="nav-link" to="/bookings">
                    Bookings
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink className="nav-link" to="/supports">
                    Support
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink className="nav-link" to="/locations">
                    Locations
                  </NavLink>
                </li>

                {/* <li className="nav-item">
                  <NavLink className="nav-link" to="/metric" >
                    Analytics
                  </NavLink>
                </li> */}
                <li className="nav-item">
                  <NavLink className="nav-link" to="/deals">
                    Deals
                  </NavLink>
                </li>
                 <li className="nav-item">
                                  <NavLink className="nav-link" to="/email-broadcast">
                                    Email Broadcast
                                  </NavLink>
                                </li>
                <li className="nav-item">
                  <NavLink className="nav-link" to="/message-templates">
                    Message Templates
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink className="nav-link" to="/app-guide">
                    App Guide
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink className="nav-link" to="/software-version">
                    Software Version
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink className="nav-link" to="/siteOnboarding">
                    Site Tracker
                  </NavLink>
                </li>

                <li className="nav-item">
                  <NavLink className="nav-link" to="/chargers">
                    Chargers
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink className="nav-link" to="/coupon-code">
                    Coupon Codes
                  </NavLink>
                </li>

                <li className="nav-item">
                  <NavLink
                    onClick={props.logout}
                    className="nav-link"
                    to="/login"
                  >
                    Logout
                  </NavLink>
                </li>
              </ul>
            </div>
          </li>
        </ul>
        {/* End Mobile screen menu */}
      </div>
    </div>
  );
};

AdminHeader.propTypes = {
  logout: PropTypes.func.isRequired,
}

AdminHeader.propTypes = {
  name: PropTypes.string,
}
const mapStateToProps = state => ({
  name: state.auth && state.auth.user ? state.auth.user.firstName : null,
});

export default connect(mapStateToProps, { logout })(AdminHeader);